module.exports = __webpack_public_path__ + "img/apple.41c9e9d1.png";